<template>
 
  <router-view></router-view>
 
</template>

<script>

export default {
  name: 'App',
  created() {

    // `this` 指向 vm 实例
 



  },
  methods:{

  }



 
}
</script>

<style >
 #app{
   margin:0;
   height: 100%;
   padding:0;
 }
 /* 在全局样式文件中，如 App.vue 或 main.css */
:root {
  /* 修改主题色 */
  --td-brand-color:  rgb(16, 155, 86);
 
}
</style>
